import React from 'react'
import BindBankCard from "@src/views/BindBankCard";

export interface IRouteBase {
  // 路由路径
  path?: string
  // 路由组件
  component?: any
  // 302 跳转
  redirect?: string
  // 路由信息
  meta?: IRouteMeta
  // 是否校验权限, false 为不校验, 不存在该属性或者为true 为校验, 子路由会继承父路由的 auth 属性
  auth?: boolean
}

export interface IRouteMeta {
  title: string
  icon?: string
}

export interface IRoute extends IRouteBase {
  children?: IRoute[]
}

const routes: IRoute[] = [
  {
    path: '/',
    component: React.lazy(() => import('@src/views/QueryReport')),
    meta: {
      title: '瑞思雷达-查询报告',
    },
  },
  {
    path: '/query',
    component: React.lazy(() => import('@src/views/QueryReport')),
    meta: {
      title: '瑞思雷达-查询报告',
    },
  },
  {
    path: '/queryReport',
    component: React.lazy(() => import('@src/views/QueryReport')),
    meta: {
      title: '瑞思雷达-查询报告',
    },
  },
  {
    path: '/reports/:orderId',
    component: React.lazy(() => import('@src/views/Report')),
    meta: {
      title: '瑞思雷达-报告详情',
    },
  },
  {
    path: '/reportSamples/:templateId',
    component: React.lazy(() => import('@src/views/Sample')),
    meta: {
      title: '瑞思雷达-报告模板',
    },
  },
  {
    path: '/success',
    component: React.lazy(() => import('@src/views/Invite/components/Success')),
    meta: {
      title: '瑞思雷达-注册成功',
    },
  },
  {
    path: '/invite',
    component: React.lazy(() => import('@src/views/Invite')),
    meta: {
      title: '瑞思雷达-邀请注册',
    },
  },
  {
    path: '/orders',
    component: React.lazy(() => import('@src/views/Orders')),
    meta: {
      title: '瑞思雷达-我的订单',
    },
  },
  {
    path: '/example',
    component: React.lazy(() => import('@src/views/Report')),
    meta: {
      title: '瑞思雷达-报告示例',
    },
  },
  {
    path: '/login',
    component: React.lazy(() => import('@src/views/Login')),
    meta: {
      title: '瑞思雷达-登录',
    },
  },
  {
    path: '/recharge',
    component: React.lazy(() => import('@src/views/Recharge')),
    meta: {
      title: '瑞思雷达-代理商充值',
    },
  },
  {
    path: '/rechargeSuccess',
    component: React.lazy(() => import('@src/views/Recharge/components/RechargeSuccess')),
    meta: {
      title: '瑞思雷达-充值成功',
    },
  },
  {
    path: '/authorize/wx',
    component: React.lazy(() => import('@src/views/Authorize/WxAuth')),
    meta: {
      title: '瑞思雷达-微信授权支付',
    },
  },
  {
    path: '/gold-plan',
    component: React.lazy(() => import('@src/views/GoldPlan')),
    meta: {
      title: '瑞思雷达-支付成功',
    },
  },
  {
    path: '/cashier',
    component: React.lazy(() => import('@src/views/Cashier')),
    meta: {
      title: '瑞思雷达-收银台',
    },
  },
  {
    path: '/paymentReceipt',
    component: React.lazy(() => import('@src/views/PaymentReceipt')),
    meta: {
      title: '收银台-小票',
    },
  },
  {
    path: '/bindBankCard',
    component: React.lazy(() => import('@src/views/BindBankCard')),
    meta: {
      title: '银行卡绑定',
    },
  },

  {
    path: '/face',
    component: React.lazy(() => import('@src/views/Face')),
    meta: {
      title: '瑞思雷达-实名认证',
    },
  },
  {
    path: '/faceResult',
    component: React.lazy(() => import('@src/views/Face/result')),
    meta: {
      title: '瑞思雷达-人脸识别',
    },
  },
]

export default routes
